import { useContext } from 'react'
import { AuthContext, AuthContextType } from '../../utilities/customHooks';
import AdminDashboard from './AdminDashboard';
import FounderDashboard from './FounderDashboard';
import IpExpertDashboard from './IpExpertDashboard';

import ProviderDashboard from './ProviderDashboard';
import GrowthCoachDashboard from './GrowthCoachDashboard';
import FirmOnboardingWizard from '../ServiceProviderPages/FirmOnboardingWizard';
import QueryBoundary from '../../Components/QueryBoundary';

function Console() {
  const { userRole, firmProfileStatus } = useContext(AuthContext) as AuthContextType; // [NOTE] This casting is intentional

  const getDashboard = () => {
    switch (userRole) {
      case "superAdmin":
      case "partnerAdmin":
      case "auditor":
        return <AdminDashboard />;
      case "serviceProvider":
        if (firmProfileStatus === 'draft') return <FirmOnboardingWizard />;
        return <ProviderDashboard />;
      case "ipExpert":
          return <IpExpertDashboard />;
      case "startupFounder":
        return <FounderDashboard />;
      case "growthCoach":
        return <GrowthCoachDashboard />;
      default:
        throw new Error('Unknown user role');
    }
  }
  return (
    <QueryBoundary>
      {getDashboard()}
    </QueryBoundary>
  )
}

export default Console